import $ from 'jquery';

export default {
    show(el:string):Promise<void> {
        return new Promise((resolve) => {
            // @ts-ignore
            $(el).modal({
                backdrop: 'static',
                keyboard: false,
            });

            resolve();
        })        
    },
    hide(el:string):Promise<void> {
        return new Promise((resolve) => {
            // @ts-ignore
            $(el).modal('hide');

            resolve();
        })
    },
    /**
     * Só resolve quando a animação de fechamento termina. Use quando outro modal
     * vai abrir logo em seguida: abrir o segundo durante a transição do primeiro
     * deixa o backdrop preso na tela.
     */
    hideAndWait(el:string, timeoutMs:number = 600):Promise<void> {
        return new Promise((resolve) => {
            let settled = false;

            const finish = () => {
                if (settled) {
                    return
                }

                settled = true;
                resolve();
            }

            // Se o modal já estiver fechado, 'hidden' não dispara e a promise
            // ficaria pendente para sempre.
            setTimeout(finish, timeoutMs);

            // @ts-ignore
            $(el).one('hidden.bs.modal', finish);
            // @ts-ignore
            $(el).modal('hide');
        })
    },
}
